import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Tag from 'shopper/components/Tag/V2';

import { toStoreCouponsLink, toStoreOffersLink } from 'lib/links';

const TIMELINES = [
  {
    name: 'Ofertas',
    getUrl: toStoreOffersLink,
    icon: 'fire',
  },
  {
    name: 'Cupons',
    getUrl: toStoreCouponsLink,
    icon: 'ticket-simple',
  },
];

export const stripHashMark = (url) => url.split('#')[0];

const TimelineNavigator = ({ className, storeSlug }) => {
  const router = useRouter();

  return (
    <nav className={twJoin('flex gap-x-4', className)}>
      {TIMELINES.map(({ icon, name, getUrl }) => {
        const url = getUrl(storeSlug);
        const isActive = stripHashMark(router.asPath) === url;

        return (
          <NextLink key={name} href={url} prefetch={false} passHref>
            <Tag
              as="a"
              clickable={!isActive}
              filled={isActive}
              iconLeft={<Icon name={icon} />}
              size="size1"
              type={isActive ? 'primary' : 'neutral'}
              bold
            >
              {name}
            </Tag>
          </NextLink>
        );
      })}
    </nav>
  );
};

TimelineNavigator.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  storeSlug: PropTypes.string.isRequired,
};

export default TimelineNavigator;
